import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { ProductCustomBannerMessageDS } from './product-custom-banner-message-ds'
import { ProductCustomBannerMessageLegacy } from './product-custom-banner-message-legacy'

import type { ProductCustomBannerMessageProps } from './product-custom-banner-message.types'

export type { ProductCustomBannerMessageProps }

export const ProductCustomBannerMessage = (props: ProductCustomBannerMessageProps) => {
  if (shouldUseDesignSystem()) {
    return <ProductCustomBannerMessageDS {...props} />
  }
  return <ProductCustomBannerMessageLegacy {...props} />
}

export default ProductCustomBannerMessage
